import HttpService from '@/services/HttpService';
import { EindbeoordelingKeuringRequestDto } from '@/domain/interface/activiteit/eindbeoordeling/EindbeoordelingKeuringRequestDto';
import EindbeoordelingKeuringStooktoestelClass from '@/domain/interface/activiteit/eindbeoordeling/EindbeoordelingKeuringStooktoestelClass';
import NotificationService from '@/services/NotificationService';
import { i18n } from '@/main';

export default class EindbeoordelingService {
  constructor(private readonly http: HttpService, private readonly notificationService: NotificationService) {}

  public async createEindbeoordelingKeuring(eindbeoordeling: EindbeoordelingKeuringRequestDto): Promise<EindbeoordelingKeuringStooktoestelClass> {
    const result = await this.http.post<EindbeoordelingKeuringStooktoestelClass>('/eindbeoordeling/keuring', eindbeoordeling);
    this.notificationService.showSuccessMessage({ detail: i18n.t('success-alert-messages.eindbeoordeling-keuring-opgeslagen') });
    return new EindbeoordelingKeuringStooktoestelClass(result);
  }

  public async updateEindbeoordelingKeuring(url: string, eindbeoordeling: EindbeoordelingKeuringRequestDto): Promise<EindbeoordelingKeuringStooktoestelClass> {
    const result = await this.http.put<EindbeoordelingKeuringStooktoestelClass>(url, eindbeoordeling);
    this.notificationService.showSuccessMessage({ detail: i18n.t('success-alert-messages.eindbeoordeling-keuring-opgeslagen') });
    return new EindbeoordelingKeuringStooktoestelClass(result);
  }
}
